import {AnswerTemplateDto} from "../domain/dtos";
import {Company} from "@livechat/shared";

export function dtoToFormValue(template: Partial<AnswerTemplateDto>, companies: Array<Company>) {
  return {
    ...template,
    companiesIds: (template.companiesIds || []).map(companyId => {
      return companies.find(c => c.companyId === companyId);
    }).filter(c => !!c) as Array<Company>
  }
}

export function formValueToDto(template: AnswerTemplateDto) {
  return {
    ...template,
    companiesIds: template.companiesIds.map((company: any) => (company as Company).companyId),
    selected: false
  }
}
